import { useState } from "react";
import { Link } from "react-router-dom";
import api from "../../services/api";
import { useUser } from "../../context/UserContext";

export default function PortalProfilePage() {
  const { user, login, logout } = useUser();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [logoutOtherSessions, setLogoutOtherSessions] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  async function handleSubmit(event) {
    event.preventDefault();
    if (loading) return;

    setError("");
    setSuccess("");

    if (!currentPassword || !newPassword || !confirmPassword) {
      setError("Vul alle velden in.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("Nieuw wachtwoord en herhaling zijn niet gelijk.");
      return;
    }

    if (newPassword.length < 10) {
      setError("Nieuw wachtwoord moet minimaal 10 tekens bevatten.");
      return;
    }

    try {
      setLoading(true);
      const res = await api.post("/auth/change-password", {
        currentPassword,
        newPassword,
        logoutOtherSessions,
      });

      const token = String(res?.data?.accessToken || "").trim();
      if (token) {
        login(token, String(res?.data?.refreshToken || "").trim());
      }

      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
      setSuccess("Wachtwoord gewijzigd.");
    } catch (err) {
      setError(err?.response?.data?.message || "Wachtwoord wijzigen mislukt");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 via-white to-blue-50 px-4 py-6 sm:px-6">
      <div className="mx-auto max-w-4xl space-y-4">
        <header className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
          <nav className="mb-2 text-xs text-slate-500">
            <Link to="/portaal" className="hover:underline">Dashboard</Link>
            <span className="px-1">/</span>
            <span className="font-semibold text-slate-700">Profiel</span>
          </nav>
          <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">Klantportaal</p>
          <h1 className="text-2xl font-bold text-slate-900">Profiel & beveiliging</h1>
          <p className="text-sm text-slate-600">
            Ingelogd als <span className="font-semibold">{user?.email || "-"}</span>
          </p>
        </header>

        <section className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
          <h2 className="text-base font-semibold text-slate-900">Wachtwoord wijzigen</h2>
          <form className="mt-4 space-y-3" onSubmit={handleSubmit}>
            <label className="block">
              <span className="mb-1 block text-sm font-medium text-slate-700">Huidig wachtwoord</span>
              <input
                type="password"
                autoComplete="current-password"
                value={currentPassword}
                onChange={(event) => setCurrentPassword(event.target.value)}
                className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
                required
              />
            </label>

            <label className="block">
              <span className="mb-1 block text-sm font-medium text-slate-700">Nieuw wachtwoord</span>
              <input
                type="password"
                autoComplete="new-password"
                value={newPassword}
                onChange={(event) => setNewPassword(event.target.value)}
                className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
                required
              />
            </label>

            <label className="block">
              <span className="mb-1 block text-sm font-medium text-slate-700">Herhaal nieuw wachtwoord</span>
              <input
                type="password"
                autoComplete="new-password"
                value={confirmPassword}
                onChange={(event) => setConfirmPassword(event.target.value)}
                className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
                required
              />
            </label>

            <label className="flex items-center gap-2 text-sm text-slate-700">
              <input
                type="checkbox"
                checked={logoutOtherSessions}
                onChange={(event) => setLogoutOtherSessions(event.target.checked)}
              />
              Andere sessies uitloggen
            </label>

            {error ? (
              <div className="rounded-lg border border-rose-200 bg-rose-50 px-3 py-2 text-sm text-rose-700">
                {error}
              </div>
            ) : null}
            {success ? (
              <div className="rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-2 text-sm text-emerald-700">
                {success}
              </div>
            ) : null}

            <div className="flex items-center gap-2 pt-1">
              <button
                type="submit"
                disabled={loading}
                className="rounded-lg bg-blue-700 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-800 disabled:opacity-60"
              >
                {loading ? "Opslaan..." : "Wachtwoord opslaan"}
              </button>
              <button
                type="button"
                onClick={logout}
                className="rounded-lg border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
              >
                Uitloggen
              </button>
            </div>
          </form>
        </section>
      </div>
    </div>
  );
}
